<script>import { createEventDispatcher, getContext } from "svelte";
import { formReset } from "../../../actions/formReset.js";
export let type;
export let contextKey;
const ctx = getContext(contextKey);
let { name, empty, dirty, focus, visited, disabled, value } = ctx;
let initialValue = $value;
let state = {
  empty: $empty,
  dirty: $dirty,
  focus: $focus,
  visited: $visited,
  disabled: $disabled
};
const dispatch = createEventDispatcher();
const setType = (node) => {
  node.type = type;
};
$: {
  $empty = $value === void 0;
  $dirty = !$disabled ? ($value !== void 0 || !initialValue != void 0) && $value !== initialValue : false;
  $focus = !$disabled ? $focus : false;
  $visited = !$disabled ? $visited : false;
  let changes = {};
  if ($empty != state.empty) {
    changes.empty = $empty;
  }
  if ($dirty != state.dirty) {
    changes.dirty = $dirty;
  }
  if ($focus != state.focus) {
    changes.focus = $focus;
  }
  if ($visited != state.visited) {
    changes.visited = $visited;
  }
  state = { empty: $empty, dirty: $dirty, focus: $focus, visited: $visited, disabled: $disabled };
  if (Object.keys(changes).length > 0) {
    dispatch("state", { changes, state });
  }
}
const onInputEvent = (ev) => {
  const elem = ev.target ? ev.target : void 0;
  if (elem) {
    if (!$empty || !!$value) {
      dispatch("changed", {
        name,
        value: $value
      });
    }
  } else {
  }
};
</script>

<input
	use:setType
	use:formReset
	bind:value={$value}
	{name}
	disabled={$disabled}
	autocomplete="off"
	on:focus={() => {
		$visited = true;
		$focus = true;
	}}
	on:blur={() => {
		$focus = false;
	}}
	on:input={onInputEvent}
/>
